import { Navigate } from "react-router-dom";

// Age groups are now read-only lookup data -- no edit page needed.
// Redirect to teams page.
export default function AgeGroupEditPage() {
  return <div data-page="age-group-edit" data-state="redirect"><Navigate to="/teams" replace /></div>;
}
